import styled from "styled-components";

export const ModalStyles = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-contact {
    display: flex;
    flex-direction: column;
    justify-content: start;
    background-color: #172736;
    padding: 2rem;
    border-radius: 1rem;
    /* #47586c  */
    box-shadow: 0 0 0.3rem rgb(115, 148, 152);
    max-width: 40rem;
    height: 30rem;
    width: 100%;

    > button:first-of-type {
      height: 2rem;
      font-size: 1rem;
      align-self: flex-end;
      width: auto;
      padding: 0rem 0.5rem;
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: #fff;
      font-weight: 700;
    }
  }
`;
